import { APIPriceRange } from 'services/api/entities/catalog/types'
import { standardPricingVS } from './standardPricing'
import { yupArray } from 'services/yup/custom-schemas/array'
import { KTestConfig, KTestFunction } from 'services/yup'

// !VALIDATIONS
const uniqueMaxQuantityValidation: KTestFunction<APIPriceRange[]> = (prices) =>
  !!prices?.every(
    (currentPrice) =>
      prices.filter((price) => price.maxQuantity === currentPrice.maxQuantity)
        .length === 1
  )

const hasEveryRangeAPriceValidation: KTestFunction<APIPriceRange[]> = (
  prices
) =>
  !!prices?.every(
    (currentPrice) => currentPrice.fixedPrice || currentPrice.variablePrice
  )

// !CONFIGS
const isEveryMaxQuantityDifferent: KTestConfig<APIPriceRange[]> = {
  name: 'isEveryMaxQuantityDifferent',
  test: uniqueMaxQuantityValidation,
  message: 'form.validations.noDuplicateMaxQuantityInPricing',
}

const hasEveryRangeAPrice: KTestConfig<APIPriceRange[]> = {
  name: 'hasEveryRangeAPrice',
  test: hasEveryRangeAPriceValidation,
  message: 'form.validations.everyPriceRangeHasPrice',
}

// !VS
export const standardPricingArrayVS = yupArray(standardPricingVS)
  .test(isEveryMaxQuantityDifferent)
  .test(hasEveryRangeAPrice)
